import "@datadog/browser-logs/bundle/datadog-logs";
import { inspect } from "@xstate/inspect";
import { type BootConfig, Env } from "../../../types";
import { getSessionId } from "../../utils/session";

declare global {
  interface Window {
    DD_LOGS: any;
  }
}

export const bootSetup = (config: BootConfig) => {
  const isXstateDebuggerEnabled =
    import.meta.env.VITE_SHOW_XSTATE_DEBUGGER === "true";

  if (config.env !== Env.production && isXstateDebuggerEnabled) {
    inspect({
      iframe: false,
    });
  }

  const { datadog } = config;
  if (datadog) {
    window.DD_LOGS.init({
      clientToken: datadog.clientToken,
      site: "datadoghq.com",
      service: datadog.serviceName,
      version: datadog.reactVersion,
      env: config.env,
      sampleRate: 100,
      trackInteractions: true,
      beforeSend: (log: any) => {
        log.browser_session_id = getSessionId();
        log.path = window.location.pathname;
      },
    });
  }
};
